import { useCollectionYardVisitReceipt } from "../../../hooks/useCollectionYardVisitReceipt";
import { Icon } from "../../Icon";
import styles from "./DownloadVisitReceipt.module.scss";
import { Icons, formattedDateTime } from "../../../utils";
import { useTranslation } from "react-i18next";
import { BoxWithDividerLines } from "../../BoxWithDividerLines";

type DownloadVisitReceiptProps = {
  visitId: number;
  created: string;
  priceSum: number;
};

const DownloadVisitReceipt = ({ visitId, created, priceSum }: DownloadVisitReceiptProps) => {
  const { t } = useTranslation();
  const { downloadReceipt, loading } = useCollectionYardVisitReceipt();

  const onDownloadClick = () => {
    if (!loading) downloadReceipt(visitId, created);
  };

  if (priceSum <= 0) return null;

  const item = [
    {
      id: visitId,
      element: (
        <div className={styles.item} onClick={onDownloadClick}>
          <div className={styles.iconCircle}>
            <Icon name={Icons.invoice} />
          </div>
          <div className={styles.itemContent}>
            <span className={styles.title}>{t("receipt")}</span>
            <span className={styles.subtitle}>{formattedDateTime(new Date(created))}</span>
          </div>

          <div className={styles.itemActions}>
            <Icon name={Icons.download} />
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <h4 className={`${styles.subtitle} ${styles.receiptTitle}`}>{t("receipt")}</h4>
      <BoxWithDividerLines style={{ padding: "0.55rem" }} items={item} />
    </div>
  );
};

export default DownloadVisitReceipt;
